<ng-container *transloco="let t">
    <div fxFill fxLayoutAlign="center center">
        <mat-card appearance="outlined">
            <div fxLayout="column" fxLayoutAlign="space-between center">
                <img
                    src="assets/img/application-icons/success.svg"
                    alt="Success"
                />
                <h2 mat-dialog-title>
                    {{ t("application.success.title") }}
                </h2>
                <div
                    [innerHTML]="
                        $safeNavigationMigration(client?.confirmationHeaderHtml)
                    "
                ></div>
                @for (provider of providerContacts; track provider) {
                <div>
                    <p>
                        <a
                            target="_blank"
                            href="{{ provider.webSite }}"
                            rel="noopener"
                            >{{ provider.providerName }}</a
                        ><br />
                        @if ( provider.address !== null && provider.address !==
                        '' ) {
                        <span> {{ provider.address }}<br /> </span>
                        } @if ( provider.contactName !== null &&
                        provider.contactName !== '' ) {
                        <span>
                            {{ t("shared.field.contact") }}:
                            {{ provider.contactName }}<br />
                        </span>
                        }
                        {{ t("shared.field.phone") }}:
                        {{ provider.contactPhoneNumber }}<br />
                        {{ t("shared.field.email") }}:
                        <a href="mailto: {{ provider.contactEmail }}">{{
                            provider.contactEmail
                        }}</a
                        ><br />
                    </p>
                </div>
                }
                <div
                    [innerHTML]="
                        $safeNavigationMigration(client?.confirmationFooterHtml)
                    "
                ></div>
            </div>
        </mat-card>
    </div>
</ng-container>
